const IndianMovies = [
  {
    id: 1,
    title: "Laal Singh Chaddha",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABW0xoLNpkLDU1U3c_ByeWsPH0lRPkwRlwUDTd21WXwjgm7hnt-mmeOdV_4p5mPXq5XGpM7dUXuO9cUe4Wzw8ePwJb6d9yVVTBRU.jpg?r=ff0",
  },
  {
    id: 2,
    title: "Ek Villian Returns",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABRDETHDXd8p5PimEMGW4ERRqFB7jHtUJLDs2bJK6QVGCczhJMpqUarfUEnrQik8n0lVw6uwh5OPyqOL37U8nJFzbO3LAjkPoX_I.jpg?r=f05",
  },

  {
    id: 3,
    title: "Bhool Bhulaiyaa 2",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABU1GT69L_oacarAC3tet376Abb6WmInLXvAgydb_x3qjcLSBbcl7JeZhiRRNH0vwq7631y2cxbLhbeR5f7XnM-aYbLwzsymseKc.jpg?r=2af",
  },
  {
    id: 4,
    title: "Gangubai Katiawadi",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABV21RJxyLtq8rP1lUPoWE3-Yliho3mwEnbERldfTQeeNsYAC14czGS1G05bpg8Fx4p2cW_48Swd24CZUq3AM3E9gzRn-YP7dYbg.jpg?r=786",
  },

  {
    id: 5,
    title: "Jogi",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABTa6Q_fBrWWtxYGyKXUtfDqrMTprFYJkSOjH8n8XuR9JnseCsjUpklXCP8H-ZWf0JLjcaLmAXP6Kcv9ObVLbNZUHs50oyAqH4p587G2TB3OVf0neR5ktCr-_sR0aPtM1xUFZ.jpg?r=1e1",
  },
  {
    id: 6,
    title: "RRR",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABTwPfIT3_obHiuYG2VDTuM-wHN1E4JiCguBBtTz7jEX79fgs4vfSMM8KGLiep2bND3tjpJS7lAGUBCAmA3vkhQ-Ue7uhrz66RbE.jpg?r=7ac",
  },
  {
    id: 7,
    title: "Beast",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABU9go7YfcWmRuAX5h38cCSmpOyETvHf_cQ4nPnWwG_PR5LY6O629KpQKjsi6EJ1vXOdy-Zbndl3s_mdto0IcVS1zID126FAeqks.jpg?r=b8a",
  },
  {
    id: 8,
    title: "Darlings",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABZZSDbL2bYAV26gYyrZ1ghUOgFo4-MLp1ucMloBMgkAzv0hOUapvV_VGt50dCk07vJci97HVDDDLAcUz0I2imWlm8mGR4N0omV8b159dqIHP_BbRHk79htLd95aWF6lQnynw.jpg?r=67e",
  },
  {
    id: 9,
    title: "Sooryavanshi",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABTQfWc_0ldHqORMZm7SCZEEenfLONtEysdiBH96IpqOyJENphwadlzkgCCVXcOYA0SJFKHqMHxKIDrR2uNKUmn9n3Z7zjmKyqTI.jpg?r=947",
  },
  {
    id: 10,
    title: "Saakini Daakini",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABf8EiAjaAEQxmabeUU0EF0E37H05YT7rZuNk3wt6R2OdfQD64lTTXxUpfF-ckvCTTNvLJue7-Zn3D8LLeY9PS-H0j957C2uUNbs.jpg?r=a87",
  },
  {
    id: 11,
    title: "Hit",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABTjVoHV3mRZgMpU44Ldo4I0jGJoaNFmlOAF1RH00UoUJnm0mfuUdQ7P9J90UidPoAev9PGBz5N6X5EyxBIelV7hlxmVGwxaN-2k.jpg?r=e7a",
  },
  {
    id: 12,
    title: "Plan A plan B",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABRmRhu_XXPIAThuLkQ-WXqRaIJ2gWuqC7McevJahFYW9rA-Hq_ZNV63r0y4qDyg9t1VPD3m-pvx16cKzBEr_oTj3duj5vjYWUznVi9eReAVmeAYBuq8XuWogKU4WNE25B72u.jpg?r=963",
  },
  {
    id: 13,
    title: "Kabir Singh",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABdTNMr-E_BMgjqAr8SmdJt_g_5QzZI3qJmfOO7FxK9J4T1PxvrWsrUogv-KVxhb-YzKjpc35VGmwn3A09E5MuI9GuYPusOFaDfM.jpg?r=31d",
  },
  {
    id: 14,
    title: "Jaadugar",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABbaCTy5qJq3ehBFA4WDOGUi156De6ySLn0BfbD3oo9_-nw5geCXOiyPIobg-SRX15rUv10sWe6fPUy7ER24sCSXGdBJJ_07hzXXNlqBo-VBAAyq9p3mKrvBHzKsX2sQ2Td_1.jpg?r=cc7",
  },
  {
    id: 15,
    title: "Major",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABde8KxBGt8eG5e9V2kJRBhlP5p6HJwl8eBVPOIKdlIqDA9oFaRp13Lgn6-wdN99D7nBzeHB__EeJi5laTMalZDIO0yEjohScv-E.jpg?r=ea1",
  },
  {
    id: 16,
    title: "Lust Stories",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABZgI1VSZH7ZO834EEIeFh0me6VtdWOemaDakoNqvHysnMtqKgU4b_tsrfHYsOtIByGXh0fFLbcKVe3GOMowqAvjN0_VKWsdmHHU-XPZMNV_iJIIwiqKYInGY2xfXkRoQ-_iz.jpg?r=161",
  },
  {
    id: 17,
    title: "Radhe Shyam",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABTpLEwkvEfPak5mETHnYs48toAn2567ZhjCfuWlIwtzOVz2CzLSNcvwCIcF6Q98u9QUA3GlHMlm_ysurfPMNnxfIhciCrDCeuEM.jpg?r=d0d",
  },
  {
    id: 18,
    title: "3 Idiots",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABdiiMG9N6nSuyJYTqoDokveSWgMzRJIUKaSm2a8gvD5oo0tabHhRqd6UmugPgWOwWsR187CZ4dX70yFqOitnUWcyhtuGUvX_tcM.jpg?r=6a8",
  },
  {
    id: 19,
    title: "Saaho",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABT0uGvK-izpYAmxnlPLAUwPT45bw2CFHiiSIt1ZRD3SqTJngUYFD0hM8FSQVrgpZZ1PkW8LCjSuhX8ka6ar6zoNH8ZaWtVzivis.jpg?r=df2",
  },
  {
    id: 20,
    title: "Mimi",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABYXBvCwy1E24RQezIeMNBkAV4pw1Es_qPUIEsKqn9owCFIJp_MQ2Jeq6bhxutryVwSxjYQYuliruwi5ejKbNc9VJWGBDbs24efs.jpg?r=f15",
  },
];


export default IndianMovies;
